<template>
  <div>
    <div class="comm_popup_wrap_xlarge">
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_SITE_ABBR')"
              :vertical="false"
              required
            />
          </div>
          <div class="col-xs-3">
            <cmp-site-select
              ref="siteSelect"
              :pageId="pageId"
              :selected="frame0.selectedCode.COD_SITE"
            />
            <!-- <sui-text-field placeholder="" :disabled="true" :readonly="false"></sui-text-field> -->
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_HDQT_DSRT_NM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-text-field
              v-model="frame0.locationName"
              maxlength="50"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_HDQT_DSRT_EN_NM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-text-field
              v-model="frame0.locationEnglishName"
              maxlength="50"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_GEHS_RGST_YN')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-yn-select
              ref="gehsRegistrationYn"
              :selected="frame0.selectedCode.COD_RGST_YN"
              :initialSelectedIndex="0"
              :defaultOption="'all'"
            />
          </div>
          <div class="col-xs-1 nodata" />
          <div class="col-xs-3" />
          <div class="col-xs-1 nodata" />
          <div class="col-xs-3" />
        </div>
        <div class="btn_wrap">
          <sui-button
            type="button"
            class="comm_btn_Reset"
            @click="onClickReset"
          >
            {{ $t('MSG_BTN_RESET') }}
          </sui-button>
          <sui-button
            v-permission:read="pageId"
            type="button"
            class="comm_btn_Scr"
            @click="onClickSearch"
          >
            {{ $t('MSG_BTN_SEARCH') }}
          </sui-button>
        </div>
      </div>
      <sui-grid
        ref="grid"
        :columns="gridColumns0"
        :dataset="'dsDistrict'"
        :rowMovable="false"
        :multiselect="false"
        :pageable="false"
        :sortable="false"
        :filterable="false"
        :showDisplayCountControl="false"
      />
    </div>
    <div class="comm_btn_wrap mrR30">
      <sui-button
        type="button"
        class="comm_btn_border"
        @click="onClickCancel"
      >
        {{ $t('MSG_BTN_CANCEL') }}
      </sui-button>
      <sui-button
        type="button"
        class="comm_btn_solid"
        @click="onClickSelect"
      >
        {{ $t('MSG_BTN_SELT') }}
      </sui-button>
    </div>
  </div>
</template>
<script>
// import Vue from 'vue';
// import checkBoxComponents from '~common/components/form/SuiCheckbox/SuiCheckbox';
// eslint-disable-next-line import/no-unresolved
import BasePage from '~cm/components/BasePage';

const dateFields = [
  'firstRegistrationDTM', 'finalModificationDTM', 'pageUsePriodStartDatetime', 'pageUsePriodFinishDatetime',
];
export default {
  name: 'PGE_CMY_00007_P01', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    pageId: {
      type: String,
      default: null,
    },
    siteId: {
      type: String,
      default: null,
    },
    siteName: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      frame0: {
        selectedCode: {
          COD_SITE: {
            key: '',
            label: '',
          },
          COD_RGST_YN: {
            key: 'N',
            label: '',
          },
        },
        locationEnglishName: '',
        locationName: '',
      },
      localdata0: [],
      gridColumns0: [{
        text: '',
        datafield: 'checkYn',
        align: 'center',
        width: '40',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellCheckbox(row, column, value, htmlElement, {
          }, this.dsDistrict, this.$refs.grid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
        cellClassName: 'ta_c',
      }, {
        text: 'No.',
        datafield: 'dataset-row-id',
        width: '60px',
        hidden: true,
      }, {
        text: this.$t('MSG_TXT_HDQT_SITE_ABBR'),
        datafield: 'siteName',
        width: 200,
      }, {
        text: this.$t('MSG_TXT_HDQT_DSRT_NM'),
        datafield: 'jobDistrictName',
      }, {
        text: this.$t('MSG_TXT_HDQT_DSRT_EN_NM'),
        datafield: 'jobDistrictEnglishName',
      }, {
        text: this.$t('MSG_TXT_BIZ_SECT_DIV'),
        datafield: 'businessSectorDivisionName',
        width: 100,
      }, {
        text: this.$t('MSG_TXT_HDQT_LOC_ID'),
        datafield: 'headquarterJobDistrictId',
        width: 100,
      }, {
        text: utils.strFormat(this.$t('MSG_TXT_GEHS_RGST_YN_SITE'), this.siteName),
        datafield: 'gehsRegistrationName',
        width: '200px',
      }],
    };
  },
  computed: {
    // 계산된 속성, date pickproperty로 사용가능
  },
  watch: {},
  datasets: [{
    id: 'dsDistrict',
    type: 'local',
    data: 'localdata0',
    datafields: [
      { name: 'checkYn', type: 'string', map: 'checkYn' },
      { name: 'dataset-row-id', type: 'string', map: 'dataset-row-id' },
      { name: 'headquarterSiteId', type: 'string', map: 'headquarterSiteId' },
      { name: 'headquarterJobDistrictId', type: 'string', map: 'headquarterJobDistrictId' },
      { name: 'jobDistrictName', type: 'string', map: 'jobDistrictName' },
      { name: 'jobDistrictEnglishName', type: 'string', map: 'jobDistrictEnglishName' },
      { name: 'jobDistrictNoteContent', type: 'string', map: 'jobDistrictNoteContent' },
      { name: 'gehsUseYn', type: 'string', map: 'gehsUseYn' },
      { name: 'gehsRegistrationYn', type: 'string', map: 'gehsRegistrationYn' },
      { name: 'arrayalOrder', type: 'string', map: 'arrayalOrder' },
      { name: 'businessSectorDivisionCode', type: 'string', map: 'businessSectorDivisionCode' },
      { name: 'siteName', type: 'string', map: 'siteName' },
      { name: 'businessSectorDivisionName', type: 'string', map: 'businessSectorDivisionName' },
      { name: 'gehsRegistrationName', type: 'string', map: 'gehsRegistrationName' },
    ],
  }],
  mounted() {
    this.frame0.selectedCode.COD_SITE.key = this.siteId;
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    /**
     *  닫기
     */
    onClickCancel() {
      this.$emit('closePopup');
    },
    /**
     *  선택
     */
    onClickSelect() {
      const checkData = utils.clone(this.dsDistrict.data);
      // const selectedData = this.dsDistrict.getSelectedRows();

      utils.remove(checkData, index => !utils.isEqual(index.checkYn, 'Y'));

      this.$emit('dataSelected', checkData, '01');
      this.$emit('closePopup');
    },
    /**
     *  초기화
     */
    onClickReset() {
      utils.forEach(this.frame0, (value, key) => {
        if (!utils.isEqual(key, 'selectData')) {
          this.frame0[key] = '';
        } else {
          this.$refs.gehsRegistrationYn.reset();
        }
      });
    },
    /**
     *  검색
     *  단지 목록 조회
     */
    onClickSearch() {
      const queryParams = {
        headquarterSiteId: this.frame0.selectedCode.COD_SITE.key,
        jobDistrictEnglishName: this.frame0.locationEnglishName,
        jobDistrictName: this.frame0.locationName,
        gehsRegistrationYn: this.frame0.selectedCode.COD_RGST_YN.key,
        headquarterJobDistrictId: '',
        siteId: this.siteId,
      };

      http.request(this.pageId, 'DTS_CMY_00032', {
        query: queryParams,
      }).then(res => {
        utils.dateformatToClientInArray(res.data, dateFields);
        this.dsDistrict.setRawData(res.data);
      });
    },
  },
};
</script>
<style scoped>
</style>
